// extracted by mini-css-extract-plugin
export default {"testElementContainer":"style_testElementContainer__M3a2x","questionNumber":"style_questionNumber__z28ie"};